import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const getBookings = createAsyncThunk('UpcomingBooking/getBookings', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverUpcomingBooking', params, {mode:'cors'})
    
    return response.data
  })
  export const getUserID = createAsyncThunk('UpcomingBooking/getUserID', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Common/GetDecodedUserID', params, {mode:'cors'})
    
    return response.data
  })

   export const getIncomingBookings = createAsyncThunk('UpcomingBooking/getIncomingBookings', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverIncomingBooking', params, {mode:'cors'})
    return response.data
  })

  export const updateAllocateIncomingBooking = createAsyncThunk('UpcomingBooking/UpdateAllocateIncomingBooking', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateAllocateIncomingBooking', params, {mode:'cors'})
    return response.data
  })
  
  export const CheckOnJob = createAsyncThunk('UpcomingBooking/ChekOnJob', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/CheckOnJobStatus', params, {mode:'cors'})
    return response.data
  })

  export const CheckDriverStatus = createAsyncThunk('UpcomingBooking/CheckDriverStatus', async (params) => {
   const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverStatus', params, {mode:'cors'})
    return response.data
  })

  export const getDriverDetail = createAsyncThunk('DriverStatusDashboard/getDriverDetail', async (GetDriver) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriver', GetDriver, { mode: 'cors' })
    return response.data
  })
  export const getBookingsHistory = createAsyncThunk('BookingHistory/getBookingsHistory', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingDriverHistory', params, {mode:'cors'})
     
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getBookingsToday = createAsyncThunk('DriverDashboard/getBookingsToday', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverEarnings', params, {mode:'cors'})
    return response.data
  })

  export const getBookingHistorydetails = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBooking', params, {mode:'cors'})
    return response.data
  })

  export const getBookingdetails = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingDetails', params, {mode:'cors'})
    return response.data
  })
  export const CheckBookingTime = createAsyncThunk('UpcomingBooking/CheckDriverStatus', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingTime', params, {mode:'cors'})
     
     return response.data
   })
  export const AddBookingJourneyProgress = createAsyncThunk('UpcomingBooking/AddBookingJourneyProgress', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/AddBookingProgress', params, {mode:'cors'})
    return response.data
  })

  export const WhatsappCall = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
    const response = await axios.post('https://api.whatsapp.com/send?phone=', params, {mode:'cors'})
    return response.data
  })

  export const confirmBooking = createAsyncThunk('UpcomingBooking/confirmBooking', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/ConfirmBooking', params, {mode:'cors'})
    return response.data
  })
  export const COABooking = createAsyncThunk('UpcomingBooking/COABooking', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingStatus', params, {mode:'cors'})
    return response.data
  })
  export const startRideBooking = createAsyncThunk('UpcomingBooking/startRideBooking ', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
  })

  export const AddRideLocationLog = createAsyncThunk('UpcomingBooking/AddRideLocationLog ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/AddLiveLocationLog', params, { mode: 'cors' })
    return response.data
  })

  export const CheckLocation = createAsyncThunk('UpcomingBooking/CheckLocation', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingLiveLocationList', params, {mode:'cors'})
    return response.data
  })

  export const rejectBooking = createAsyncThunk('UpcomingBooking/rejectBooking', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/RejectBooking', params, {mode:'cors'})
    return response.data
  })
    
  export const updateBookingStatusOnRoute = createAsyncThunk('UpcomingBooking/updateBookingStatusOnRoute ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
    return response.data
  })

  export const GetDrNotifications = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverNotifications', params, { mode: 'cors' })
    return response.data
  })

  export const setIsNotified = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateIsNotified', params, { mode: 'cors' })
    return response.data
  })

export const UpcomingBookingSlice = createSlice({
    name: 'UpcomingBooking',
    initialState: {
      data: [],
      NotificationData: [],
      historydata: [],
      total: 1,
      params: {},
      allData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder
        
      .addCase(getBookingsHistory.fulfilled, (state, action) => {
        
          state.historydata = action.payload.data
          state.params = action.payload.params
          state.total = action.payload.totalPages
          
      })

      .addCase(getBookings.fulfilled, (state, action) => {
        state.data = action.payload
      })
           
      // .addCase(GetBookingEditNotif.fulfilled, (state, action) => {
      //   state.BookEdit = action.payload.list
      //   state.lastrec = action.payload.lastrecord.bookingID
      // })

      // .addCase(setBookingEd.fulfilled, (state) => {
      //   state.EditPrevLen = state.BookEdit.length
      // })
    }
})

export default UpcomingBookingSlice.reducer
